<template>
    <form v-bind:action="requestUri" @submit.prevent="submit(requestUri,'post')" method="post" class="text-center">
        <h1 class="mb-3 page-title">ورود/ثبت نام</h1>
        <p class="subtitle">به پدینی مارکت خوش آمدید.</p>
        <div v-if="!loading" class="alert alert-info text-center mt-5" style="font-size: 12px;">کد تایید به شماره {{mobile}} ارسال شد.</div>
        <div class="input-group mt-1 mb-3">
            <span class="input-group-text" id="basic-addon1"><i class="fa fa-mobile"></i></span>
            <input type="text"
                   id="token"
                   placeholder="کد تایید"
                   aria-label="کد تایید"
                   class="form-control text-center"
                   :class="{'is-invalid':hasError('token')}"
                   v-model="form.token"
                   maxlength="11"
            >
            <div v-html="feedbackHtml('token')"></div>
        </div>
        <div class="form-group d-grid mb-3">
            <button class="btn btn-primary" type="submit" :disabled="loading">
                <span>تایید</span>
                <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </div>
        <div class="form-group d-grid mb-3">
            <button :disabled="remainingTime || loading" class="btn btn-secondary" type="button" @click="request">
                <span v-if="remainingTime">ارسال مجدد کد ({{remainingTime}})</span>
                <span v-else>ارسال مجدد کد</span>
            </button>
        </div>
        <div class="form-group mb-5 text-center">
            <a href="#" style="font-size: 0.8em;" @click="changeNumber">تغییر شماره موبایل</a>
        </div>
    </form>
</template>

<script>
import SimpleAjaxForm from "../general/SimpleAjaxFormMixin";
export default {
    name: "VerifyOtp",
    props: {
        mobile: {required: true, type: String}
    },
    emits: ['onCancel', 'update:modelValue'],
    mixins: [SimpleAjaxForm],
    data() {
        return {
            requestUri: "/api/v1/otp/verify",
            now: Math.floor(Date.now() / 1000),
            requestTime: Number(localStorage.getItem('_otp_time')),
            form : {
                mobile: this.mobile,
                token: '',
            },
        }
    },
    methods: {
        successful(response) {
            localStorage.setItem('_token', response.data.token);
            localStorage.removeItem('_otp_time');
            localStorage.removeItem('_otp_mobile');
            this.$emit('update:modelValue', response.data.token);
            window.location.href = '/profile';
        },
        successfulToast() {

        },
        request() {
            this.loading = true;
            const config = {
                headers: { Authorization: `Bearer ${this.token()}` }
            };
            this.axios.post("/api/v1/otp/request", {mobile: this.mobile}, config)
                .then(response => {
                    this.requestTime = Math.floor((Date.now()) / 1000);
                    localStorage.setItem('_otp_time', this.requestTime);
                    this.$forceUpdate();
                    this.loading = false;
                })
                .catch(error => {
                    if (typeof error.response !== 'undefined' && error.response.status === 429) {
                        this.requestTime = Math.floor((Date.now()) / 1000);
                        localStorage.setItem('_otp_time', this.requestTime);
                        this.$forceUpdate();
                    } else {
                        this.errorToast('خطا در ارسال کد');
                    }
                    this.loading = false;
                });
        },
        changeNumber() {
            this.$emit('cancel');
        }
    },
    created() {
        setInterval(() => {
            this.now = Math.floor(Date.now() / 1000);
        }, 1000);
    },
    computed: {
        remainingTime() {
            if (this.requestTime && (this.requestTime + 120) > this.now ) {
                const seconds = this.requestTime + 120 - this.now;
                return Math.floor(seconds / 60)+':'+seconds % 60;
            }
            return 0;
        }
    }
}
</script>

<style scoped>

</style>
